import { useMemo } from 'react'
import { getOamProviders, configureOamSettings } from 'api/line'
import { CrawlWizardModal } from './CrawlWizardModal'

type Props = {
  open: boolean
  onClose: () => void
}

export function OamSettingsModal({ open, onClose }: Props) {
  const config = useMemo(() => ({
    title: '初期設定',
    cookieDescription: (
      <>
        <p className="text-sm text-muted mb-2">全アカウントに以下を一括実行します:</p>
        <ul className="text-sm text-ink mb-4 list-disc pl-5">
          <li>プロバイダーへの紐付け（Messaging API有効化）</li>
          <li>チャット: <strong>OFF</strong></li>
          <li>あいさつメッセージ: <strong>OFF</strong></li>
          <li>自動応答メッセージ: <strong>OFF</strong></li>
        </ul>
        <p className="text-xs text-muted mb-4">Webhook URL登録とWebhook ONは、次のチャンネル連携で実行します。</p>
        <p className="text-xs text-muted mb-2">
          <a href="https://manager.line.biz" target="_blank" rel="noopener noreferrer" className="text-accent underline">manager.line.biz</a> にログイン → DevTools → Network → 任意のリクエストの Cookie ヘッダーをコピーして貼り付けてください。
        </p>
      </>
    ),
    cookiePlaceholder: 'Cookie文字列を貼り付け...',
    providerSelectLabel: '紐付け先のプロバイダーを選択してください。',
    processingLabel: '設定中...',
    fetchProviders: async (cookie: string) => {
      const data = await getOamProviders(cookie)
      return data.map((p) => ({ id: p.providerId, name: p.providerName }))
    },
    execute: async (cookie: string, providerId: number) => {
      const data = await configureOamSettings(cookie, providerId)
      return {
        badges: [
          { label: '設定済み', count: data.configured, color: 'green' as const },
          ...(data.failed > 0 ? [{ label: '失敗', count: data.failed, color: 'red' as const }] : []),
        ],
        items: data.accounts.map((a) => ({
          key: a.basicId,
          name: a.name,
          id: a.basicId,
          status: a.status === 'configured' ? 'success' as const : 'failed' as const,
          statusLabel: a.status === 'configured' ? '設定済み' : '失敗',
          error: a.error,
        })),
      }
    },
  }), [])

  return <CrawlWizardModal open={open} onClose={onClose} config={config} />
}
